<template>
  <section class="hotel">
    <img src="../assets/graphics/line.svg" alt="Divider line" class="divider-ln">

    <img src="../assets/graphics/yellow-shape.svg" alt="" class="hotel__cards-shape --left">
    <img src="../assets/graphics/blue-shape.svg" alt="" class="hotel__cards-shape --right">
    <div class="hotel__content">
      <div class="hotel__banner">
        Our room block at the Condado Vanderbilt is being reserved<br>
        <a href="/#book">
          <button class="btn-new book-btn">
            See other options
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </a>
      </div>
      <div class="hotel__cards">
        <div class="hotel__card--content container">
          <div class="card --one">
            <h3 class="card__title">
                <b>Company Presentations</b>
                Public, Private and Crypto
            </h3>
            <p class="card__description">Join engaging industry panels led by visionary leaders driving innovation across the sector.</p>
          </div>
          <div class="card --two">
            <h3 class="card__title">
              <b>Hundreds</b>
              of Networking Opportunities
            </h3>
            <p class="card__description">Connect with the world's top investment leaders in a stunning tropical paradise, complete with unforgettable networking opportunities and vibrant nightly entertainment.</p>
          </div>
          <div class="card --three">
            <h3 class="card__title">
              <b>500+</b>
              Attendees & Investors
            </h3>
            <p class="card__description">Family Funds, Equity Groups, Institutional and Retail Investors and more.</p>
          </div>
        </div>
      </div>
      <div class="hotel__carousel">
        <Carousel :items-to-show="computedItemsToShow" :wrap-around="true">
          <Slide v-for="(image, index) in images" :key="index">
            <div class="hotel__carousel--item">
              <img :src="image" :alt="'Image ' + index">
            </div>
          </Slide>
          <template #addons>
            <Navigation class="carousel-nav"/>
          </template>
        </Carousel>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/hotel.scss';
</style>

<style lang="scss">
@import '@/styles/import/variables.scss';
@import '@/styles/import/mixins.scss';

  .hotel {
    .carousel__prev,
    .carousel__next {
      background-color: #fff;
      border-radius: 50%;
      &:hover {
        color: #000;
      }
    }
    .carousel-nav {
      z-index: 2;
      @include from ($breakpoint_lg) {
        margin: 0 25px;
      }
    }
    .book-btn {
      margin-top: 10px;
      font-size: 13px;
      padding: 5px 22px 7px 18px;
      svg {
        left: 7px;
      }
    }
  }
</style>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css';

export default defineComponent({
  name: 'Hotel',
  components: {
    Carousel,
    Slide,
    Navigation
  },
  computed: {
    computedItemsToShow() {
      const width = window.innerWidth;
      if (width < 500) {
        return 1.5;
      } else if (width >= 500 && width < 900) {
        return 2;
      } else if (width >= 900 && width < 1300) {
        return 2.5;
      } else {
        return 3.2;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.$forceUpdate();
    }
  },
  data() {
    return {
      images: [
        require('@/assets/event/1.png'),
        require('@/assets/event/4.png'),
        require('@/assets/event/2.png'),
        require('@/assets/event/6.png'),
        require('@/assets/hotel/hotel-3.jpeg'),
        require('@/assets/hotel/hotel-5.jpeg'),
        require('@/assets/hotel/hotel-6.jpeg'),
        require('@/assets/hotel/hotel-7.jpeg'),
        require('@/assets/hotel/hotel-7a.jpeg'),
        require('@/assets/hotel/hotel-8.jpeg'),
        require('@/assets/hotel/hotel-8a.jpeg'),
        require('@/assets/hotel/hotel-8b.jpeg'),
        require('@/assets/hotel/hotel-9.jpeg'),
        require('@/assets/hotel/hotel-10.jpeg'),
        require('@/assets/hotel/hotel-10a.jpeg'),
        require('@/assets/hotel/hotel-11.jpeg'),
        require('@/assets/hotel/hotel-11a.jpeg'),
        require('@/assets/hotel/hotel-12.jpeg'),
        require('@/assets/hotel/hotel-13.jpeg'),
        require('@/assets/hotel/hotel-13a.jpeg'),
        require('@/assets/hotel/hotel-14.jpeg'),
        require('@/assets/hotel/hotel-15.jpeg'),
        require('@/assets/hotel/hotel-16.jpeg'),
        require('@/assets/hotel/hotel-17.jpeg'),
        require('@/assets/hotel/hotel-18.jpeg'),
        require('@/assets/hotel/hotel-19.jpeg'),
        require('@/assets/hotel/hotel-20.jpeg'),
        require('@/assets/hotel/hotel-20a.jpeg'),
        require('@/assets/hotel/hotel-21.jpeg'),
        require('@/assets/hotel/hotel-22.jpeg'),
        require('@/assets/hotel/hotel-23.jpeg'),
        require('@/assets/hotel/hotel-24.jpeg'),
        require('@/assets/hotel/hotel-25.jpeg'),
        require('@/assets/hotel/hotel-26.jpeg'),
        require('@/assets/hotel/hotel-27.jpeg'),
        require('@/assets/hotel/hotel-27a.jpeg'),
        require('@/assets/hotel/hotel-28.jpeg'),
        require('@/assets/hotel/hotel-29.jpeg'),
        require('@/assets/hotel/hotel-30.jpeg'),
        require('@/assets/hotel/hotel-31.jpeg'),
        require('@/assets/hotel/hotel-2a.jpg'),
        require('@/assets/hotel/hotel-1a.jpg'),
      ],
    };
  },
});

</script>